/* import __COLOCATED_TEMPLATE__ from './config-editor.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ConfigEditorComponent extends Component
{
	@tracked cards = [];

	constructor()
	{
		super(...arguments);
		// Deep clone the initial config
		this.cards = JSON.parse(JSON.stringify(this.args.config?.cards || []));
	}

	@action addCard()
	{
		this.cards = [...this.cards, { name: 'New Card', rows: [{ links: [] }] }];
	}

	@action removeCard(cardIndex)
	{
		this.cards = this.cards.filter((_, i) => i !== cardIndex);
	}

	@action updateCard(cardIndex, updatedCard)
	{
		const newCards = [...this.cards];
		newCards[cardIndex] = updatedCard;
		this.cards = newCards;
	}

	@action downloadConfig()
	{
		const config = { cards: this.cards };
		const jsonString = JSON.stringify(config, null, 2);
		const blob = new Blob([jsonString], { type: 'application/json' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'classGroupsConfig.json';
		a.click();
		URL.revokeObjectURL(url);
	}
}
